// src/reducers/textEditorSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  textEditor: null, // For storing the text editor state
  createAttributes: '', // For storing created attributes
  createAttributesGroup: '', // For storing created attribute groups
};

// Text Editor Slice
const textEditorSlice = createSlice({
  name: 'textEditor',
  initialState,
  reducers: {
    getTextEditorState: (state, action) => {
      state.textEditor = action.payload;
    },
    createAttribute: (state, action) => {
      state.createAttributes = action.payload;
    },
    createAttributeGroup: (state, action) => {
      state.createAttributesGroup = action.payload;
    },
  },
});

// Export actions and reducer
export const { getTextEditorState, createAttribute, createAttributeGroup } =
  textEditorSlice.actions;

export default textEditorSlice.reducer;